import PropTypes from "prop-types"

import { getBadgeClass } from "helpers/product/badge"
import { cn } from "styles/utils"

const Badge = ({ className, label, variant }) => {
  const variantClass = getBadgeClass(variant)

  return (
    <span
      className={cn(
        "z-1 bg-polar text-13 desktop:left-20 desktop:top-20 h-18 absolute left-8 top-8 inline-flex min-w-80 items-center justify-center px-12 font-semibold text-black",
        variantClass,
        className
      )}
    >
      {label}
    </span>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
}

export default Badge
